'use strict';

import TopEvents from './components/TopEvents.vue';

export default {
    TopEvents
}
